// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2mv63","checkboxCol":"Table_checkboxCol__26xn7","emailCol":"Table_emailCol__2XdMC","actionCol":"Table_actionCol__TnF8-"};